import React, { useState, useRef } from 'react'
import { styles } from './index.sass'
import { Button, message, Card, Modal, Spin as AntdSpin } from 'antd'
import RichTextEditor from '../../components/richTextEditor'
import axios from '../../api/axios_ml'
import { sendEmail, sendTestEmail } from '../../api/mailchimp'
import { cleanHtmlContent } from '../../utils/htmlCleaner'

// Mock data for testing
const MOCK_GENERATE_RESPONSE = {
  status: 'success',
  content_html: {
    success: true,
    html_content: '<!DOCTYPE html>\n<html>\n<head>\n<title>Power List</title>\n</head>\n<body>\n <table width="100%" cellpadding="0" cellspacing="0" border="0">\n <tr>\n <td align="center">\n <table width="1000" cellpadding="0" cellspacing="0" border="0" style="border-collapse: collapse; max-width: 700px;">\n <tr>\n <td style="padding: 20px;">\n<p style="text-align:center;">\n <img src="https://mcusercontent.com/3912bbdcbe7acd8d33ba45619/images/a1b8f54f-069a-4f04-b373-4afaaf45e349.png" alt="Header Image" width="100%" height="auto" style="display: block; border: 0; outline: none; text-decoration: none;"/>\n</p>\n<p style="text-align:center; display: block; margin: 0; padding: 0; color: #202020; font-family: Helvetica; font-size: 20px; font-style: normal; font-weight: normal; line-height: 150%; letter-spacing: normal;">\n Today, we\'re looking at a couple of interesting studies related to sleep optimization, blood glucose management, and nutrition. Check them out below.\n</p>\n<br>\n<h1 style="text-align:center; display: block; margin: 10px 0 15px 0; padding: 0; color: #202020; font-family: Helvetica; font-size: 26px; font-style: normal; font-weight: bold; line-height: 125%; letter-spacing: normal;">Sleep Optimization Conferences You Can\'t Miss</h1>\n<p style="text-align:center; display: block; margin: 0 0 15px 0; padding: 0; color: #202020; font-family: Helvetica; font-size: 18px; font-style: normal; font-weight: normal; line-height: 150%; letter-spacing: normal;">\n Explore the latest trends in sleep optimization and discover key conferences in the field. Attend to network with top experts and learn cutting-edge techniques to enhance sleep quality.\n</p>\n<br>\n<p style="text-align:center;">\n <img src="https://images.unsplash.com/photo-1761304891654-3cdaf347cd06?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MDk2MTJ8MHwxfHNlYXJjaHwxfHxCZXN0JTIwU2xlZXAlMjBPcHRpbWl6YXRpb24lMjBDb25mZXJlbmNlcyUyMHRvJTIwQXR0ZW5kJTIwaW4lMjAyMDI2JTIwLSUyMFRoZSUyMFdhc2hpbmd0b24lMjBCZWVyJTIwQmxvZyUyMHZpYnJhbnQlMjBsaWZlc3R5bGV8ZW58MXwwfHx8MTc3NDk0MzcyN3ww&ixlib=rb-4.1.0&q=80&w=1080" alt="Article Image" width="100%" height="auto" style="display: block; border: 0; outline: none; text-decoration: none;"/>\n</p>\n<br>\n<p style="text-align:center;">\n <a target="_blank" href="https://news.google.com/rss/articles/CBMijgFBVV95cUxQTjU5NUZ6QlVrMUNPTXE3QU95Ul9lNzZBMHgxc3BnM3FxU2FYNTVOcGRMTUViTGp4c3dWRC1hOEFxX0xRRzdETHdSc0VvdGxSNzY0ZFd1WGF2dV9rVUd0YXdrSEVtcXhMN3BVa1QwMXlkbkNLX3VoUE1JZU9NTG5IV0Fjbmo2ZkV6TGhsMDlR?oc=5" style="display:inline-block; padding:10px 20px; background-color:#1e3a8a; color:#ffffff; text-decoration:none; border-radius:4px; font-weight:bold; font-family: Helvetica;">Read more</a>\n</p>\n<hr style="border:0.2px solid #dddddd; margin:30px 0;">\n<h1 style="text-align:center; display: block; margin: 0 0 15px 0; padding: 0; color: #202020; font-family: Helvetica; font-size: 26px; font-style: normal; font-weight: bold; line-height: 125%; letter-spacing: normal;">Boost Wellness with Glucose Monitoring</h1>\n<p style="text-align:center; display: block; margin: 0 0 15px 0; padding: 0; color: #202020; font-family: Helvetica; font-size: 18px; font-style: normal; font-weight: normal; line-height: 150%; letter-spacing: normal;">\n Continuous glucose monitoring can enhance health and wellness, even for those without diabetes. Discover how technology can help you manage glucose levels for optimal health outcomes.\n</p>\n<br>\n<p style="text-align:center;">\n <img src="https://images.unsplash.com/photo-1611453165495-80525f59141d?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MDk2MTJ8MHwxfHNlYXJjaHwxfHxjYW4lMjB2aWJyYW50JTIwd2VsbG5lc3N8ZW58MXwwfHx8MTc3NDk0MzcyNXww&ixlib=rb-4.1.0&q=80&w=1080" alt="Article Image" width="100%" height="auto" style="display: block; border: 0; outline: none; text-decoration: none;"/>\n</p>\n<br>\n<p style="text-align:center;">\n <a target="_blank" href="https://news.google.com/rss/articles/CBMitAFBVV95cUxPb0FzNkxJMXVXcGlZbU1VaDBEb3JDLVdrd1F6ZmtORnphaVJGQk9FSWRYN1lYMXhBMjdmQ1Z0VWxuWndYaTd3Q3ZBR0xuZHk4eWVGenAyYWt6Y3g3ckUteFJoV0RTeVNtNElWWVM2MG9fQkhsVGlIZWxKeVlkaUhzRG5WLXVtREFlYUphWVRHVkZPSkppcUs1anoyTEwyT2h5WmFlYlkzbjFwcmhNY2t6NnUyXy0?oc=5" style="display:inline-block; padding:10px 20px; background-color:#1e3a8a; color:#ffffff; text-decoration:none; border-radius:4px; font-weight:bold; font-family: Helvetica;">Read more</a>\n</p>\n<hr style="border:0.2px solid #dddddd; margin:30px 0;">\n<h1 style="text-align:center; display: block; margin: 0 0 15px 0; padding: 0; color: #202020; font-family: Helvetica; font-size: 26px; font-style: normal; font-weight: bold; line-height: 125%; letter-spacing: normal;">Increase Your Fiber Intake for Health</h1>\n<p style="text-align:center; display: block; margin: 0 0 15px 0; padding: 0; color: #202020; font-family: Helvetica; font-size: 18px; font-style: normal; font-weight: normal; line-height: 150%; letter-spacing: normal;">\n Discover the daily fiber intake needed for optimal health and its benefits. Focus on whole foods and plant-based options to enhance digestion and heart health.\n</p>\n<br>\n<p style="text-align:center;">\n <img src="https://images.unsplash.com/photo-1669355106052-b7456721510c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MDk2MTJ8MHwxfHNlYXJjaHwxfHxIb3clMjBNdWNoJTIwRmliZXIlMjBZb3UlMjBOZWVkJTIwRXZlcnklMjBEYXklMjBUbyUyMFN0YXklMjBIZWFsdGh5JTIwLSUyMEhlYWx0aCUzQSUyMFRydXN0ZWQlMjBhbmQlMjBFbXBhdGhldGljJTIwSGVhbHRoJTIwYW5kJTIwV2VsbG5lc3MlMjBJbmZvcm1hdGlvbiUyMHZpYnJhbnQlMjBsaWZlc3R5bGV8ZW58MXwwfHx8MTc3NDk4MDIyMnww&ixlib=rb-4.1.0&q=80&w=1080" alt="Article Image" width="100%" height="auto" style="display: block; border: 0; outline: none; text-decoration: none;"/>\n</p>\n<br>\n<p style="text-align:center;">\n <a target="_blank" href="https://news.google.com/rss/articles/CBMiiAFBVV95cUxPbjJRRnhfYnBqSGVJMXBJcWlGNTV4NWRKYi16bG1IbUJzVVNUYnJwdGFiUmZESkhCTExTTGQtOEhLRWlsdEN3SnY2RkMxd0JwWFFUNWtkTU1YREVkbmtUdHFMVE1GRFhoYmhLajJfZTFBeFRaaXREY29xX3o0VHhqZzdITEZwLU9n?oc=5" style="display:inline-block; padding:10px 20px; background-color:#1e3a8a; color:#ffffff; text-decoration:none; border-radius:4px; font-weight:bold; font-family: Helvetica;">Read more</a>\n</p>\n<hr style="border:0.2px solid #dddddd; margin:30px 0;">\n<h1 style="text-align:center; display: block; margin: 0; padding: 0; color: #202020; font-family: Helvetica; font-size: 26px; font-style: normal; font-weight: bold; line-height: 125%; letter-spacing: normal;">Our Take - The Apeiron Life Perspective</h1>\n<p style="text-align:center; border:1px solid #ccc; padding:20px; display: block; margin-top: 10px; color: #202020; font-family: Helvetica; font-size: 20px; font-style: normal; font-weight: normal; line-height: 160%; letter-spacing: normal;">\n The recent studies underscore the critical role of sleep optimization, blood glucose awareness, and nutritional fiber intake in enhancing overall health. Clients are encouraged to implement consistent sleep routines and utilize technology such as glucose monitors to track metabolic health. Furthermore, integrating high-fiber foods into the diet not only improves digestion but supports heart health. As always, maintaining a balanced and holistic approach to health is essential for long-term wellness.\n</p>\n<br>\n </td>\n </tr>\n </table>\n </td>\n </tr>\n </table>\n</body>\n</html>'
  }
}

export const PowerList = () => {
  const [contentHtml, setContentHtml] = useState('')
  const [isEditing, setIsEditing] = useState(false)
  const [loading, setLoading] = useState(false)
  const [editedContent, setEditedContent] = useState('')
  const editorContentRef = useRef('')

  const handleGenerate = async (regenerate = false) => {
    setLoading(true)
    try {
      // Mock data for testing (actual API call commented out below)
      // const mockResponseData = MOCK_GENERATE_RESPONSE

      // Actual API call (commented out for testing)
      const payload = regenerate ? { regenerate: true } : {}
      const response = await axios.post(
        `${process.env.REACT_APP_ML_API_ENDPOINT}/api/ml/generate-powerlist`,
        payload,
      )

      const cleanedHtml = cleanHtmlContent(
        response.content_html.html_content,
      )
      setContentHtml(cleanedHtml)
      message.success('Power List generated successfully!')
    } catch (err) {
      console.error('Error generating Power List:', err)
      message.error(
        err.message || 'Failed to generate Power List. Please try again.',
      )
    } finally {
      setLoading(false)
    }
  }

  const handleEdit = () => {
    setEditedContent(contentHtml)
    editorContentRef.current = contentHtml
    setIsEditing(true)
  }

  const handleSave = () => {
    const finalContent = editorContentRef.current || editedContent
    setContentHtml(finalContent)
    setIsEditing(false)
    message.success('Changes saved successfully!')
  }

  const handleCancel = () => {
    setEditedContent(contentHtml)
    editorContentRef.current = ''
    setIsEditing(false)
    message.info('Changes discarded')
  }

  const handleEditorChange = (html) => {
    editorContentRef.current = html
  }

  const handleCopy = async () => {
    try {
      const cleanedHtml = cleanHtmlContent(contentHtml)

      if (typeof window !== 'undefined' && window.ClipboardItem) {
        const clipboardItem = new window.ClipboardItem({
          'text/html': new Blob([cleanedHtml], { type: 'text/html' }),
          'text/plain': new Blob([cleanedHtml], { type: 'text/plain' })
        })

        await navigator.clipboard.write([clipboardItem])
      } else {
        navigator.clipboard.writeText(cleanedHtml)
      }
      message.success('Copied to clipboard')
    } catch (err) {
      const cleanedHtml = cleanHtmlContent(contentHtml)
      navigator.clipboard.writeText(cleanedHtml)
      message.success('Copied to clipboard')
    }
  }

  const handleRegenerate = () => {
    Modal.confirm({
      title: 'Regenerate Power List',
      content: 'This will replace the current content. Continue?',
      onOk: () => handleGenerate(true)
    })
  }

  const handleSendEmail = () => {
    Modal.confirm({
      title: 'Send Email',
      content: 'Are you sure you want to send this email?',
      okText: 'Send',
      cancelText: 'Cancel',
      onOk: async () => {
        try {
          const subject = 'Power List'
          const response = await sendEmail({ content: contentHtml, subject: subject })
          if (response.success === true) {
            message.success('Email sent successfully!')
          } else {
            message.error('Failed to send email. Please try again.')
          }
        } catch (err) {
          console.error('Error sending email:', err)
          message.error('Failed to send email. Please try again.')
        }
      }
    })
  }

  const handleSendTestEmail = async () => {
    try {
      const subject = 'Test Power List Email'
      const response = await sendTestEmail({ html: contentHtml, subject: subject })
      if (response.success === true) {
        message.success('Test email sent successfully!')
      } else {
        message.error('Failed to send test email. Please try again.')
      }
    } catch (err) {
      console.error('Error sending test email:', err)
      message.error('Failed to send test email. Please try again.')
    }
  }

  return (
    <div className={styles}>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-popup">
            <AntdSpin size="large" style={{ marginBottom: '16px' }} />
            <div className="loading-text">Generating content</div>
            <div className="loading-subtext">
              This will take less than 3 minutes. Please wait...
            </div>
          </div>
        </div>
      )}
      <div className="container">
        <h2>Power List Content Generator</h2>
        <div className="actions">
          <Button type="primary" onClick={handleGenerate} loading={loading}>
            Generate Power List
          </Button>
          <Button onClick={handleRegenerate} disabled={!contentHtml || loading}>
            Regenerate
          </Button>
          <Button onClick={handleCopy} disabled={!contentHtml}>
            Copy Content
          </Button>
          <Button onClick={handleEdit} disabled={!contentHtml}>
            Edit Content
          </Button>
          <Button onClick={handleSendTestEmail} disabled={!contentHtml}>
            Send test Email
          </Button>
          <Button onClick={handleSendEmail} disabled={!contentHtml}>
            Send Email
          </Button>
        </div>
        {contentHtml && (
          <Card className="content-card">
            {isEditing ? (
              <div>
                <div style={{ marginBottom: '16px', textAlign: 'right' }}>
                  <Button onClick={handleCancel} style={{ marginRight: '8px' }}>
                    Cancel
                  </Button>
                  <Button type="primary" onClick={handleSave}>
                    Save Changes
                  </Button>
                </div>
                <RichTextEditor
                  value={editedContent}
                  onChange={handleEditorChange}
                  placeholder="Edit your Power List content here..."
                />
              </div>
            ) : (
              <>
                <div
                  className="content-preview"
                  dangerouslySetInnerHTML={{ __html: contentHtml }}
                />
              </>
            )}
          </Card>
        )}
      </div>
    </div>
  )
}
